import React from 'react';
import { nanoid } from "nanoid"
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import {  useComputedColorScheme } from '@mantine/core';
import { Divider } from '@react-md/divider';
import User from '../utils/User';

import gota1 from '../assets/gota_1B.webp';
import gota2 from '../assets/gota_2.webp';
import gota3 from '../assets/gota_3.webp';
import gota4 from '../assets/gota_4.webp';
import gota5 from '../assets/gota_3.webp';
import ControlTrad from '../assets/trad/ControlTrad';

const MainFont = styled.div`
  ${(props) => `
display: flex;
flex-direction:row;
justify-content: space-between;
background-color: ${props.dark ? "#242424" : "#dfdfdf"};
cursor:pointer;
padding: 0 10px;
&:hover{
    background-color: ${props.dark ? "#3c3c3c " : "#b5b5b5"};
}
@media (max-width: 425px) {
   padding: 10px 0
}
  `}
`;

const FontType = styled.p`
margin: 0;
align-content: center;
flex: 1;

@media (max-width: 425px) {
   display:none;
}
`;


const FontID = styled.p`
margin: 0;
align-content: center;
flex: 2;

@media (max-width: 820px) {
   display:none;
}
border-left: 1px solid black;
padding-left: 5px;


`

const FontTitle = styled.p`
margin: 0;
align-content: center;
flex: 7;
margin: 0 3px;
border-left: 1px solid black;
padding-left: 5px;

`

const FontDistance = styled.p`
margin: 0;
align-content: center;
flex: 3;
border-left: 1px solid black;
padding-left: 5px;

`

const Font = (props) => {
    const navigate = useNavigate();

    const computedColorScheme = useComputedColorScheme('light', { getInitialValueInEffect: true });


    const goToNavegate = (page, id) => {
        if (page === 0) {
            navigate("/" + id);
        } else if (page === 1) {
            navigate("/edit/font/" + id);
        }
    }

    const calcDistance = (dist) => {
        if (dist !== "Desconocida") {
            if (dist >= 1) { return (dist.toFixed(2) + " km").replaceAll(".",",") }
            else { return ((dist * 1000).toFixed(0) + " m").replaceAll(".",",") }
        }
        else { return ControlTrad.getTrad("calculateUbi") }
    }


    const remplaceNumAddress = (address) => {
        if (User.getLang() === "CAT") {
            return address.replace("º", ". ").replace("°",". ");
        }
        return address;
    }

    
    return (
        <div>
            <MainFont onClick={() => { goToNavegate(0, props.font.id) }} key={nanoid()} dark={computedColorScheme === "dark"}>
                <FontType>
                    <img style={{width:'45px'}} alt={""} src={props.font.type === 1 ? gota1 : props.font.type === 2 ? gota2 : props.font.type === 3 ? gota5 : props.font.type === 4 ? gota4 : gota3} />
                </FontType>
                <FontID >{props.font.id}</FontID>
                <FontTitle >{remplaceNumAddress(props.font?.address?.toUpperCase())}</FontTitle>
                <FontDistance>{calcDistance(props.distance)}</FontDistance>
            </MainFont>
            <Divider style={{ margin: "0px" }} />
        </div>

    );

}
export default Font